module.exports = __webpack_public_path__ + "images/revista-ofertas.jpg?102a9502c3366bc2d7fb1da04a4cf33b";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/revista-ofertas.jpg
// module id = 989
// module chunks = 0